import React from "react";
import { createRoot } from "react-dom/client";
import "./css/app.css";
import reportWebVitals from "./reportWebVitals";
import Root from "./js/Root";


const root = document.getElementById("root");
let configuration = root.querySelector("[rel='configuration']");
if (configuration) {
  configuration = JSON.parse((configuration as HTMLElement).innerText);
}

createRoot(root).render(<Root {...configuration} />);

// ReactDOM.render(
//   <React.StrictMode>
//     {/* <App /> */}
//     <Root {...configuration} />
//   </React.StrictMode>,
//   root
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
